import React from 'react';
import './Separator.css'; // Create a CSS file for styling
const Separator = () => {
    return <div className="separator" />;
};
export default Separator;